import { render, staticRenderFns } from "./ModalHeaderEdit.vue?vue&type=template&id=5417d808&scoped=true&"
import script from "./ModalHeaderEdit.vue?vue&type=script&lang=js&"
export * from "./ModalHeaderEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModalHeaderEdit.vue?vue&type=style&index=0&id=5417d808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5417d808",
  null
  
)

export default component.exports